export default __webpack_public_path__ + "static/media/star_3.220a4a77.svg";